export default __webpack_public_path__ + "static/media/selectDestinationPortoSeguro.66946d13.svg";